import { tableHelper } from "@/helpers/table.helper";
import { getBlankCriteria } from "./helpers";

export const state = getInitialState();

export function getInitialState() {
  return {
    listing: {
      criteria: getBlankCriteria(),
      keepCriteria: false,
      criteriaInfo: tableHelper.getBlankCriteriaInfo(),
      data: [],
      expanded: [],
      paging: tableHelper.getDefaultPaging("ActionDate"),
      userId: null,
      loading: false,
      loaded: false
    }
  };
}

export function getUnloadedState() {
  return {
    listing: {
      loaded: false
    }
  };
}
